<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div
      class="flex items-center w-full px-4 py-3 bg-gray-800/50 cursor-pointer hover:bg-gray-700/50 transition-colors mb-2"
      [matMenuTriggerFor]="profileMenu"
      (menuOpened)="onProfileMenuOpened()"
    >
      <div class="flex-shrink-0">
        <div class="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center">
          <span class="text-white font-semibold text-sm">{{ getUserInitials() }}</span>
        </div>
      </div>
      <div class="flex-1 min-w-0 ml-3">
        <p class="text-sm font-medium text-white truncate">{{ user?.name }}</p>
        <p class="text-xs text-gray-400 truncate">{{ user?.email }}</p>
        <p *ngIf="activeSubAccountName" class="text-sm text-indigo-400 truncate mt-0.5">
          {{ 'user.viewing' | translate }}: {{ activeSubAccountName }}
        </p>
      </div>
      <div class="flex-shrink-0 ml-2">
        <mat-icon class="text-gray-400 icon-size-5" [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
      </div>
    </div>

    <mat-menu #profileMenu="matMenu" class="profile-switcher-menu">
      <div *ngIf="isLoadingProfiles" class="profile-menu-content flex justify-center py-6">
        <mat-spinner diameter="24"></mat-spinner>
      </div>

      <ng-container *ngIf="!isLoadingProfiles">
        <ng-container *ngFor="let group of profilesGrouped; trackBy: trackByAccountGroup">
          <div class="profile-menu-content px-4 pt-3 pb-2">
            <span class="text-sm font-bold text-gray-900 dark:text-white">{{ group.account.name }}</span>
          </div>

          <button
            *ngFor="let profile of group.profiles; trackBy: trackByProfile"
            mat-menu-item
            [class.bg-indigo-50]="profile.isActive"
            (click)="selectProfile(profile, $event)"
          >
            <div class="flex items-center justify-between w-full">
              <span class="text-gray-500 dark:text-gray-400">{{ profile.subAccountName }}</span>
              <mat-icon
                *ngIf="profile.isActive"
                class="text-indigo-600 ml-2 icon-size-5"
                [svgIcon]="'heroicons_outline:check'"
              >
              </mat-icon>
            </div>
          </button>
        </ng-container>

        <div *ngIf="profilesGrouped.length === 0" class="px-4 py-3 text-sm text-gray-500">
          {{ 'user.noProfiles' | translate }}
        </div>
      </ng-container>

      <mat-divider class="my-2"></mat-divider>

      <!-- Actions -->
      <button mat-menu-item (click)="changePassword()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
        <span>{{ 'user.changePassword' | translate }}</span>
      </button>
      <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{ 'user.signOut' | translate }}</span>
      </button>
    </mat-menu>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
      <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 h-screen">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <languages></languages>
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>
